import React, { useContext } from 'react';
import { StoreContext } from './context';
import FaceInfo from '../UserCenter/IdentityVerification/FacialInfo';

const Face = () => {
  const { i18n, locale, config: { transId } } = useContext(StoreContext);
  return (
    <FaceInfo
      i18n={i18n}
      locale={locale}
      mode="reset2fa"
      transId={transId}
    />
  );
};

export default Face;
